<template>
  <v-tabs v-model="tab" grow>
    <v-tab v-for="level in levels" :key="level.text">{{ level.text }}</v-tab>
    <v-tab-item v-for="(level, i) in levels" :key="level.text + i">
      <v-lazy v-if="level.value === 'rough'">
        <v-row class="fill-height" justify="center" align="center">
          <CreateRough v-model="result.rough" />
        </v-row>
      </v-lazy>
      <v-row
        v-else
        v-for="(question, i) in result[level.value]"
        :key="question.uid"
        justify="center"
        align="center"
      >
        <CreateQuestion v-model="result[level.value][i]" />
      </v-row>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import CreateRough from "./CreateAssessmentRough";
import CreateQuestion from "./CreateAssessmentQuestion";

export default {
  name: "Createlevel",
  props: {
    value: {
      type: Object
    }
  },
  components: {
    CreateRough,
    CreateQuestion
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      inView: [],
      tab: 0,
      levels: [
        { text: "grov", value: "rough" },
        { text: "a1", value: "a1" },
        { text: "a2", value: "a2" },
        { text: "b1", value: "b1" },
        { text: "b2", value: "b2" },
        { text: "c1", value: "c1" },
        { text: "c2", value: "c2" }
      ]
    };
  }
};
</script>

<style></style>
